import { render, staticRenderFns } from "./QuestionTemplate.vue?vue&type=template&id=8aaeffee&"
import script from "./QuestionTemplate.vue?vue&type=script&lang=js&"
export * from "./QuestionTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports